/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { patternFormValidator } from '@zvoove-market/shared';
import { isFileExtensionAcceptable } from '../function/file';

export const ibanFormValidator = (): ValidatorFn =>
  patternFormValidator(
    '^(?:(?:IT|SM)[0-9]{2}[A-Z][0-9]{22}' +
      '|CY[0-9]{2}[A-Z][0-9]{23}' +
      '|NL[0-9]{2}[A-Z]{4}[0-9]{10}' +
      '|LV[0-9]{2}[A-Z]{4}[0-9]{13}' +
      '|(?:BG|BH|GB|IE)[0-9]{2}[A-Z]{4}[0-9]{14}' +
      '|GI[0-9]{2}[A-Z]{4}[0-9]{15}' +
      '|RO[0-9]{2}[A-Z]{4}[0-9]{16}' +
      '|KW[0-9]{2}[A-Z]{4}[0-9]{22}' +
      '|MT[0-9]{2}[A-Z]{4}[0-9]{23}' +
      '|NO[0-9]{13}' +
      '|(?:DK|FI|GL|FO)[0-9]{16}' +
      '|MK[0-9]{17}' +
      '|(?:AT|EE|KZ|LU|XK|LT)[0-9]{18}' +
      '|(?:BA|HR|LI|CH|CR)[0-9]{19}' +
      '|(?:GE|DE|ME|RS)[0-9]{20}' +
      '|IL[0-9]{21}' +
      '|(?:AD|CZ|ES|MD|SA)[0-9]{22}' +
      '|PT[0-9]{23}' +
      '|(?:BE|IS)[0-9]{24}' +
      '|(?:FR|MR|MC)[0-9]{25}' +
      '|(?:AL|DO|LB|PL)[0-9]{26}' +
      '|(?:AZ|HU)[0-9]{27}' +
      '|(?:GR|MU)[0-9]{28})$',
    'DE12123456781234567890'
  );
export const bicFormValidator = (): ValidatorFn => patternFormValidator(/^[A-Z0-9]{4}[A-Z]{2}[A-Z0-9]{2}[A-Z0-9]{3}$/, '1234DE12345');
export const taxNrFormValidator = (): ValidatorFn => patternFormValidator(/^\d{11}$/, '01234567890');
export const vatIdFormValidator = (): ValidatorFn =>
  patternFormValidator(
    '^((AT)U[0-9]{8}' + //Austria
      '|(BE)0[0-9]{9}' + //Belgium
      '|(BG)[0-9]{9,10}' + //Bulgaria
      '|(CY)[0-9]{8}L' + //Cyprus
      '|(CZ)[0-9]{8,10}' + //Czech Republic
      '|(DE)[0-9]{9}' + //Germany
      '|(DK)[0-9]{8}' + //Denmark
      '|(EE)[0-9]{9}' + //Estonia
      '|(EL|GR)[0-9]{9}' + //Greece
      '|(ES)[0-9A-Z][0-9]{7}[0-9A-Z]' + //Spain
      '|(FI)[0-9]{8}' + //Finland
      '|(FR)[0-9A-Z]{2}[0-9]{9}' + //France
      '|(HU)[0-9]{8}' + //Hungary
      '|(IE)[0-9]S[0-9]{5}L' + //Ireland
      '|(IT)[0-9]{11}' + //Italy
      '|(LT)([0-9]{9}|[0-9]{12})' + //Lithuania
      '|(LU)[0-9]{8}' + //Luxembourg
      '|(LV)[0-9]{11}' + //Latvia
      '|(MT)[0-9]{8}' + //Malta
      '|(NL)[0-9]{9}B[0-9]{2}' + //Netherlands
      '|(PL)[0-9]{10}' + //Poland
      '|(PT)[0-9]{9}' + //Portugal
      '|(RO)[0-9]{2,10}' + //Romania
      '|(SE)[0-9]{12}' + //Sweden
      '|(SI)[0-9]{8}' + //Slovenia
      '|(SK)[0-9]{10}' + //Slovakia
      '|(CHE)-[0-9]{3}\\.?[0-9]{3}\\.?[0-9]{3}( ?(IVA|TVA|MWST))?)$', //Switzerland
    $localize`:@@vatIdformat:Europäische oder Schweizer USt-IdNr. (z.B. DE123456789, ATU12345678, CHE-123.456.789)`
  );
export const requiredIfValidator =
  (
    controlName: string,
    isRequiredFnc: (formGroup: FormGroup) => boolean,
    errorMessage: { message: string } | boolean | null,
    allowEmptyValue = false
  ): ValidatorFn =>
  (formGroup: AbstractControl) => {
    if (!(formGroup instanceof FormGroup)) {
      return null;
    }

    const formControl = formGroup.get(controlName);
    if (isRequiredFnc(formGroup) && (allowEmptyValue || !formControl?.value)) {
      addError(formGroup, [controlName], 'required_if', errorMessage);
    } else {
      removeError(formGroup, [controlName], 'required_if');
    }

    return null;
  };

export const requiredNotEmptyIfValidator =
  (
    controlName: string,
    isRequiredFnc: (formGroup: FormGroup) => boolean,
    errorMessage: { message: string } | boolean | null,
    allowEmptyValue = false
  ): ValidatorFn =>
  (formGroup: AbstractControl) => {
    if (!(formGroup instanceof FormGroup)) {
      return null;
    }

    const formControl = formGroup.get(controlName);
    if (isRequiredFnc(formGroup) && (allowEmptyValue || !formControl?.value || formControl?.value.length === 0)) {
      addError(formGroup, [controlName], 'required_if', errorMessage);
    } else {
      removeError(formGroup, [controlName], 'required_if');
    }

    return null;
  };

export const requiredTrueIfValidator =
  (
    controlName: string,
    isRequiredFnc: (formGroup: FormGroup) => boolean,
    errorMessage: { message: string } | boolean | null
  ): ValidatorFn =>
  (formGroup: AbstractControl) => {
    if (!(formGroup instanceof FormGroup)) {
      return null;
    }

    const formControl = formGroup.get(controlName);
    if (isRequiredFnc(formGroup) && formControl?.value !== true) {
      addError(formGroup, [controlName], 'required_true_if', errorMessage);
    } else {
      removeError(formGroup, [controlName], 'required_true_if');
    }

    return null;
  };

export const maxFileSizeValidator =
  (maxFileSize: number): ValidatorFn =>
  (control: AbstractControl) => {
    if (!control.value || !(control.value instanceof File)) {
      return null;
    }

    if (control.value.size > maxFileSize) {
      return {
        maxFileSize: {
          maxFileSize: maxFileSize,
        },
      };
    }

    return null;
  };

export const acceptableFileExtensionsValidator =
  (extensions: string[]): ValidatorFn =>
  (control: AbstractControl) => {
    if (!control.value || !(control.value instanceof File)) {
      return null;
    }

    if (!isFileExtensionAcceptable(control.value.name, extensions)) {
      return {
        acceptableFileExtensions: {
          acceptableExtensions: extensions,
        },
      };
    }

    return null;
  };

export const minDateValidator = (minDate: Date): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    const date = new Date(control.value);
    if (minDate.getTime() <= date.getTime()) {
      return null;
    } else {
      return { min: { value: control.value, min: minDate } };
    }
  };
};
export const maxDateValidator = (maxDate: Date): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    const date = new Date(control.value);
    if (maxDate.getTime() >= date.getTime()) {
      return null;
    } else {
      return { max: { value: control.value, max: maxDate } };
    }
  };
};

export const noDuplicateKeysValidator =
  (keyName: string, errorMessage: { message: string } | boolean | null): ValidatorFn =>
  (formArray: AbstractControl) => {
    if (!(formArray instanceof FormArray)) {
      return null;
    }

    const keyOccurences: Record<string, number[]> = {};
    formArray.controls.forEach((control: AbstractControl, index: number) => {
      if (control instanceof FormGroup) {
        const item = control.value;
        if (item[keyName]) {
          keyOccurences[item[keyName]] = keyOccurences[item[keyName]] || [];
          keyOccurences[item[keyName]].push(index);
        }
      }
    });

    for (const key in keyOccurences) {
      const indices = keyOccurences[key];
      if (indices.length > 1) {
        for (const index of indices) {
          const arrayGroup = formArray.at(index);
          if (arrayGroup instanceof FormGroup) addError(arrayGroup, [keyName], 'duplicate_key', errorMessage);
        }
      } else {
        const arrayGroup = formArray.at(indices[0]);
        if (arrayGroup instanceof FormGroup) removeError(arrayGroup, [keyName], 'duplicate_key');
      }
    }

    return null;
  };

export const addError = (
  formGroup: FormGroup,
  controlNames: string[],
  errorKey: string,
  errorValue: { message: string } | boolean | null = true
): void => {
  for (const controlName of controlNames) {
    const control = formGroup.controls[controlName];
    const errors = control.errors || {};
    errors[errorKey] = errorValue;
    control.setErrors(errors);
  }
};

export const removeError = (formGroup: FormGroup, controlNames: string[], errorKey: string): void => {
  for (const controlName of controlNames) {
    const control = formGroup.controls[controlName];
    let errors: ValidationErrors | null = control.errors || {};
    if (errors && Object.keys(errors).indexOf(errorKey) !== -1) {
      delete errors[errorKey];
      if (Object.keys(errors).length === 0) {
        errors = null;
      }
      control.setErrors(errors);
    }
  }
};
